import { CurrencyOptions } from '../../../../contexts/CurrencyContext';
import { getDefaultFilterOptions } from '../default';

export function getInventoryFilterOptions(currencyOptions: CurrencyOptions) {
  return [...getDefaultFilterOptions(currencyOptions)];
}
